import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import SystemActions from '../../actions/system/system-actions'
import UserFacingAPIReturnTypes from '../../common/UserFacingAPIReturnTypes'
import AnimateState from '../../lib/io/BrianCorr/AnimateState'

// TODO: break out the UI component to have the messages as a prop
//  then have this system one use the component
//  then we have a generic in case devs want to use one for in-game messages
//  then use for TOC in-game messages
export const SystemMessageCP = (props) => {
  const [messageProps, setMessageProps] = useState({})
  const [animCtrls, setAnimCtrls] = useState({})
  
  function updateMessProp (id, val) {
    // if you do not send a function to an update state function
    //  it will (always?) return stale state.
    //  I don't even know why there is an option to not.
    //  This whole thing seems ... well it doesn't inspire confidence 
    setMessageProps(messageProps => {
      let newMessProps = { ...messageProps }
      newMessProps[id] = val
      return newMessProps
    })
  }

  function removeMessProp (id) {
    // see note above
    setMessageProps( messageProps => {
      let newMessProps = { ...messageProps }
      delete newMessProps[id]
      return newMessProps
    })
  }

  function addCtrl (id, ctrl) {
    setAnimCtrls( animCtrls => {
      let newAnimCtrls = { ...animCtrls }
      newAnimCtrls[id] = ctrl
      return newAnimCtrls
    })
  }

  function removeCtrl (id) {
    setAnimCtrls( animCtrls => {
      let newAnimCtrls = { ...animCtrls }
      delete newAnimCtrls[id]
      return newAnimCtrls
    })
  }

  function makeCtrl (id) {
    let animCtrl = AnimateState.makeAnimationController(5000)
    animCtrl.timeline.onFrame = function (pct) {
      // hold for 4 seconds then linear fade out
      pct = (1-pct)*5
      pct = Math.min(pct, 1)
      updateMessProp(id, pct)
    }
    animCtrl.timeline.onDeInit = function () {
      // TODO: can we batch these?
      // note: this order matters
      props.removeSystemMessage(id)
      removeCtrl(id)
      removeMessProp(id)
    }
    updateMessProp(id, 1.0)
    addCtrl(id, animCtrl)
    return animCtrl
  }

  useEffect(() => {
    Object.values(props.systemMessages).forEach((message) => {
      if (!(message.timestamp in animCtrls)) {
        // new one!
        let animCtrl = makeCtrl(message.timestamp)
        animCtrl.run()
      }
    })
  }, [props.systemMessages])
  
  let rows = []
  Object.values(props.systemMessages).forEach((message) => {
    if (message.timestamp in messageProps) {
      let mType = message?.type
      mType = UserFacingAPIReturnTypes?.[mType] || UserFacingAPIReturnTypes['error']
      let typeClass = `${mType}-message`
      let opacity = messageProps[message.timestamp]
      rows.push(
        <div style={{'opacity': opacity}} className={`sys-message-item ${typeClass}`} key={message.timestamp}>- {message.message}</div>
      )
    }
  })

  return (
    <div id='sys-message'>
      {/*
      <div style={{'opacity': 1}} className={`sys-message-item error-message`} key='test_1'>Test 1</div>
      <div style={{'opacity': 1}} className={`sys-message-item success-message`} key='test_2'>Test 2</div>
      */}
      {rows}
    </div>
  )
}

const mapStateToProps = (state) => ({
  systemMessages: state.system.systemMessages,
})

const mapDispatchToProps = (dispatch) => {
  return {
    removeSystemMessage: (messageId) => dispatch(SystemActions.removeSystemMessage(messageId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemMessageCP)
